const STORE_KEY = 'SUBJECT'

export const FETCH_SUBJECT = `${STORE_KEY}/FETCH_SUBJECT`
